import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  NOTIFICATIONS_FEATURE_KEY,
  State,
  NotificationPartialState,
  notificationAdapter
} from './notification.reducer';

export const getNotificationState = createFeatureSelector<
  NotificationPartialState,
  State
>(NOTIFICATIONS_FEATURE_KEY);

const { selectAll, selectEntities } = notificationAdapter.getSelectors();

export const getNotificationLoading = createSelector(
  getNotificationState,
  (state: State) => state.loading
);

export const getNotificationError = createSelector(
  getNotificationState,
  (state: State) => state.error
);

// export const getAllNotifications = createSelector(getNotificationState, (state: State) => selectAll(state)); // not used

export const getUnreadNotifications = createSelector(
  getNotificationState,
  (state: State) => selectAll(state)
);

export const getNotificationEntities = createSelector(
  getNotificationState,
  (state: State) => selectEntities(state)
);
